import { Automation, Button, ButtonStyle, Call, cursorNone, DataFromUrl, handleOtherResponseCode, getClientUsers, INTERVIEW_TYPES, JOB_STAGES, PageStyle, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, 
         REDIRECT, startDateMessage, Tech, toastr, User, Video, CustomToastrAction, VideoQA, INTERVIEW_TYPE_HEADERS, previewJob} from "@/imports-files/pages/clients/jobs/automations";
import { VideoQAModalService } from "@/imports-files/components/model/setup-video-qa"; 

  const MAX_ALLOWED_RECORDS = 5;
  export function handleDelete(formik, index, itemIndex){
    let member_emails = formik.values.job_meeting_details_attributes[index].member_emails
    let member_initials = formik.values.job_meeting_details_attributes[index].member_initials
  member_emails.splice(itemIndex, 1)
    member_initials.splice(itemIndex, 1)
    formik.setFieldValue(`job_meeting_details_attributes[${index}].member_emails`, [...member_emails])
    formik.setFieldValue(`job_meeting_details_attributes[${index}].member_initials`, [...member_initials])
  };

  export function onSuggestionSelection(old_ids, id, old_initials, new_initial){
    if(!(old_ids.includes(id) || old_ids.includes(id.toString())))
     {
      old_ids.unshift(id)
      old_initials.unshift(new_initial)
     } 
  }

  export function initialStageValues(initialValues)
  {
    return initialValues.job_meeting_details_attributes.map((x) => 
      {return {value: ''}}
    )
  }

  export function showHideButtonValue(values){
    let total_count = values.job_meeting_details_attributes.filter((x) => !x._destroy)?.length
    return total_count < MAX_ALLOWED_RECORDS ? true : false
  }

  export function onAutomationChange(...args){
    const formik = args[0]
    const action = args[1]
    const index =  args[2]!=undefined ? args[2] : 0;
    const currentStage = args[3];
    const setStageEmail = args[4];
    const setInterviewStageCount = args[5];
    const setTotalDuration = args[6];
    const setShowHideButton = args[7];
    const member_emails = args[8] || [];
    const member_initials = args[9] || [];
    let automations = formik.values.job_meeting_details_attributes
    let correct_records = formik.values.job_meeting_details_attributes?.filter((record) => !record._destroy).length || 0
    if(action == "add"){
      let interview = {
        member_ids: [],
        member_emails: member_emails,
        member_initials: member_initials,
        duration: '',
        interview_type: currentStage.interview_type,
        _destroy: false
      }
      if(currentStage.interview_type == INTERVIEW_TYPES.VIDEO)
      {
        interview.meeting_platform_attributes = {integration_id: ''}
      }
      else if(currentStage.interview_type == INTERVIEW_TYPES.FACE2FACE){
        interview.location_attributes = {full_address: currentStage?.default_location || '' }
      }
      automations.push(interview)
    }
    else{
      automations[index]['_destroy'] = true
    }
    setStageEmail(initialStageValues(formik.values))
    setInterviewStageCount(automations.filter((x) => !x._destroy).length)

    let durations = []
    let total_count = 0
    formik.values.job_meeting_details_attributes.map((x, itemIndex) => {
      if(!x._destroy){ 
        let numer_duration = parseInt(x.duration) || 0
        durations.push(numer_duration)
        total_count += 1;
      }
      else{
        durations.push(0)
      }
      return x;
    })
    setTotalDuration(durations.reduce((a,b) => a+b, 0))
    total_count < MAX_ALLOWED_RECORDS ? setShowHideButton(true) : setShowHideButton(false);
  }
  // function getSuggestionValue(suggestion) {
  //   return `${suggestion.email}`;
  // }
  export function showSuggestion(suggestion){
    if(suggestion.user_attributes.name && (suggestion.user_attributes.email.length > 0)){
      return `${suggestion.user_attributes.name} | ${suggestion.user_attributes.email}`
    }
    else if(suggestion.user_attributes.name){
      return `${suggestion.user_attributes.name}`
    }
    else{
      return `${suggestion.user_attributes.email}`
    }
  }
  export function renderSuggestion(suggestion) {
    return (
      <span>{showSuggestion(suggestion)}</span>
    );
  }
  export function shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }

  function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  const onAddClick = (event, params) => {
    let email = params.value 
    if(isEmail(email)){
      onSuggestionSelection(params.formik.values.job_meeting_details_attributes[params.index].member_emails, email, params.formik.values.job_meeting_details_attributes[params.index].member_initials, {email: email, name_initials: null, name: null })
      params.stageEmail[params.index] = {value: '', error: ''}
      params.setStageEmail([...params.stageEmail])
    }
    else{
      params.stageEmail[params.index] = {value: email, error: 'Please enter valid email'}
      params.setStageEmail([...params.stageEmail])
    }
  }

  export function handleKeyDown(event, formik, index, stageEmail, setStageEmail){
    if (["Enter"].includes(event.key)) {
      event.preventDefault();
      let email = event.target.value 
      if(isEmail(email)){
        onSuggestionSelection(formik.values.job_meeting_details_attributes[index].member_emails, email, formik.values.job_meeting_details_attributes[index].member_initials, {email: email, name_initials: null, name: null })
        stageEmail[index] = {value: '', error: ''}
        setStageEmail([...stageEmail])
      }
      else{
        stageEmail[index] = {value: email, error: 'Please enter valid email'}
        setStageEmail([...stageEmail])
      }
    }
  }
  export const renderInputComponent = inputProps => (
    <div className="buttonIn">
      <input className = {PageStyle.Form__Input} autoComplete="password"
      {...inputProps} />
      <Button buttonstyle={`${ButtonStyle.nobgbutton} addbtn ${cursorNone(inputProps.editable)}`} disabled={inputProps.disabled} onClick={(event) => onAddClick(event, inputProps)}>Add</Button>
    </div>
  );
  
  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async function getSuggestions(value, currentStage, router) {
    const escapedValue = escapeRegexCharacters(value.trim());
    
    if (escapedValue === '') {
      return [];
    }
  
    const regex = new RegExp('^' + escapedValue, 'i');
    let finalUsers = await getClientUsers(escapedValue, 3, router)
    // return currentStage.members.filter((member) => regex.test(member.email) || regex.test(member.name));
    return finalUsers;
  }
  
  export async function onSuggestionsFetchRequested(value, currentStage, setUsers, router){    
    let users = await getSuggestions(value, currentStage, router)
    setUsers(users)
  };

  export function renderLabel(intervieType) {
    switch(intervieType) {
      case INTERVIEW_TYPES.VIDEO:
        return (<label>Platform *</label>);
      case INTERVIEW_TYPES.PHONE:
        return '';
      default: 
        return '';
    }
  }

  export function interviewStageName(jobStage)
  {
    return jobStage.label;
    // return (jobStage.stage === JOB_STAGES.INTERVIEW ? jobStage.label : jobStage.stage )
  }

  export function testDuration(){
    let duration = []
    for (let i=1; i < 15; i++) {
      duration.push({label: i, value: i})
    }
    return duration;
  }
         
  export function automationText(jobStage){
    let editSetup = jobStage.button_text
    let text = "";
    
    if(jobStage.stage == JOB_STAGES.APPLIED)
      {
        text = 'I’d like to automatically progress candidates who reach my set score.'
      }
    else if (jobStage.stage == JOB_STAGES.SCREENING) {
      let interview_type_text = jobStage.interview_type ? `a ${jobStage.interview_type?.toLowerCase()}` : 'an'
      text = `Yes please. Automatically organise ${interview_type_text} interview for best match candidates.`
    }  
    else if([JOB_STAGES.INTERVIEW].includes(jobStage.stage))
      {
        text = `I’m keen to arrange ${jobStage.interview_type?.toLowerCase()} interview at ${ jobStage.label }`
      }
    return text;
  }
       
  export function interviewTypeIcon(type) {
    switch(type) {
      case INTERVIEW_TYPES.PHONE:
        return <Call className='AutomationIcons'/>;
      case INTERVIEW_TYPES.TECHTEST:
        return <Tech className='AutomationIcons'/>;
      case INTERVIEW_TYPES.VIDEO:
        return <Video className='AutomationIcons'/>;
      case INTERVIEW_TYPES.FACE2FACE:
          return <User className='AutomationIcons faceIcon'/>;
      case INTERVIEW_TYPES.VIDEOQA:
          return <VideoQA className='AutomationIcons'/>
    }
  }

  export function userHash(user){
    return {email: user.email, name_initial: user.name_initials, name: user.name }
  }
       
  export function addInitalInterview(jobStage){
    let interview = {
      member_ids: jobStage.members.map((x) => x.id ) || [],
      member_emails: jobStage.members.map((x) => x.email ) || [],
      member_initials: jobStage.members.map((x) => userHash(x) ) || [],
      duration: '',
      _destroy: false,
    }
    if(jobStage.interview_type == INTERVIEW_TYPES.VIDEO){
      interview.meeting_platform_attributes ={ integration_id: ''}
    }
    else if(jobStage.interview_type == INTERVIEW_TYPES.FACE2FACE){
      interview.location_attributes ={ full_address: jobStage?.default_location || ''}
    }
    jobStage.job_meeting_details_attributes.push(interview)
    return jobStage;
  }
      
   function addVideoInterviewQA(jobStage){
    
    let interview = {language: 'English',
                                                video_link: '',
                                                questions_attributes: [{question: '', description: '', attempts: 2, answer_time: 30, _destroy: false}],
                                                job_stage_attributes: {automation: false},
                                                practise_screen: false,
                                                expires: ''
}
    jobStage.job_meeting_details_attributes.push(interview)
    return jobStage;
  }

  export async function mangeInterviews(jobId, jobStage, setCurrentStage, setBtnPopup, router, isOpen)
  {
    let jobStageData = await getJobStageData(jobId, jobStage.id, router);

    if(jobStageData.job_meeting_details_attributes.length == 0 && [INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(jobStageData.interview_type))
    {
      jobStageData = addInitalInterview(jobStageData)
    }
    setCurrentStage(jobStageData)
    setBtnPopup(isOpen)
  }
       
  export function getBgClass(jobStage){
    if ([JOB_STAGES.OFFERED, JOB_STAGES.HIRED, JOB_STAGES.APPLIED].includes(jobStage.stage))
      { return `${PageStyle.Automation__FormRowHeading} ${PageStyle.rowbglight}` }
    else 
      { return `${PageStyle.Automation__FormRowHeading}` }
  }
              


export async function updateThreshold(args){
  const jobId                 =   new DataFromUrl().getJobId();
  const result                =   await new Automation().setThreshold(args.values, jobId, args.jobStageId);
  const status_code           =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    if(args.from == "job-form")
    { args.setOnLoadValues({job: {job_stages_attributes: result.data.job_stages_attributes, threshold: result.data.daxtra_threshold}}) }
    else if(args.from == "kanban")
    {
      args.jobData.daxtra_threshold = response.daxtra_threshold
      args.setJobData(args.jobData)
    }
    args.setBtnPopup(false)
    return response;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
  default: 
    handleOtherResponseCode(status_code, args.router);
  }
}

export async function handleInterviewFormSubmit(params, router, jobStageId, setBtnPopup, setOnLoadValues, from, jobData, setJobData, setDisabled, deleteQuestionList){
  setDisabled(true)
  const customToastrAction    =   new CustomToastrAction();
  if(params.interview_type == INTERVIEW_TYPES.FACE2FACE){
    params.job_meeting_details_attributes = params.job_meeting_details_attributes.map((x) => {
      x.location_attributes = { full_address: params.default_location || '', place_id: params.place_id || ''}
      return x
    })
  }
  const job_id        =     new DataFromUrl().getJobId();
  const body          =     {job_stage: {automation: params.automation, interview_type_id: params.interview_type_id, job_meeting_details_attributes: params.job_meeting_details_attributes} }
  
  if(params.interview_type == INTERVIEW_TYPES.TECHTEST){
    let techTestBody  =   setTechTestFormData(params)
    body.job_stage.job_test_detail_attributes = techTestBody.job_stage.job_test_detail_attributes
    if(techTestBody.assessment) body.assessment = techTestBody.assessment
    if(techTestBody.save_and_continue) body.save_and_continue = techTestBody.save_and_continue
  }

  if(params.interview_type == INTERVIEW_TYPES.VIDEOQA){
    let questions_attributes = Object.assign( [], params.questions_attributes, deleteQuestionList)
    let video_question_details_attributes = {
      language: params.language,
      video_link: params.video_link,
      practise_screen: params.practise_screen,
      expires: params.expires,
      member_emails: params.videoqa.member_emails,
      questions_attributes: Object.assign( [], params.questions_attributes, deleteQuestionList)
    }
    body.job_stage.video_question_details_attributes = video_question_details_attributes
  }
  body.from = from
  const result        =     await new Automation().addAutomations(body, job_id, jobStageId );
  const status_code   =     result.status || result.response.status;
  
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      if(from == "kanban")
      {
        setJobData(result.data.kanban_data)
        if(result.data.success && from == 'kanban') customToastrAction.setNormalToastr(result.data.success, 'success');
      }
      else if(from == "job-form"){
        // customToastrAction.setNormalToastr("Interview details updated successfully.", 'success');
        let current_updated_stage = result.data
        setDisabled(false)
        return {success: true, updated_stage: current_updated_stage}
        // setOnLoadValues({job: {job_stages_attributes: result.data.job_stages_attributes}})
      }
      setBtnPopup(false)
      break;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    setDisabled(false)
    let message = "";
    if(result.response.data.error.job_stage?.new_user_emails){
      if(message.length > 0) { message += "</br>"}
      message += `${result.response.data.error.job_stage.new_user_emails}`
    }
    if(message.length > 0) { new CustomToastrAction().setNormalToastr(message, 'warning');
                             }
    if(from == "job-form"){
      return {success: false, errors: result.response.data.error.job_stage}
    }else{
      return result.response.data.error.job_stage
    }
  default: 
    handleOtherResponseCode(status_code, router);
  }
} 

export async function handleAutomationFormSubmit(params, router, setPageName, queryClient, fromKanban, gotoKanban, setDisabledSaveButton, submitState, setSubmitState)
{
  setDisabledSaveButton(true);
  // var job_id   =  window.location.pathname.split('/').slice(-2)[0];
  var job_id                  =     new DataFromUrl().getJobId();
  const result                =     await new Automation().updateAutomations(params, job_id );
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    if(['draft', 'preview'].includes(submitState)){
      setSubmitState('');
      if(submitState == 'preview') previewJob(router, job_id)
      if(submitState == 'draft') customToastrAction.setNormalToastr(response.success.replace('updated successfully.', 'saved as draft'), 'success');
      setDisabledSaveButton(false)
      return;
    }

    let queryPath = fromKanban ? "?from_kanban=true" : ""
    if(gotoKanban){
      if(fromKanban){
        router.push({pathname: REDIRECT.client.kanban_board.replace('$job_id', job_id)});
      }
      else{
        router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'Active' } });
      }
    }
    else
      { router.push(REDIRECT.client.jobs.scorecards.replace('$job_id', job_id)+queryPath) }
    break;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    setSubmitState('');
    let message = "";
    if(result.response.data.error.job?.base) { message = startDateMessage(message, result.response.data.error.job?.base)}
    if(message.length > 0)
    {
      customToastrAction.setNormalToastr(message, 'warning');
      // toastr.warning(message)
    }
      setDisabledSaveButton(false);
    break;
  default: 
    setSubmitState('');
    handleOtherResponseCode(status_code, router);
      setDisabledSaveButton(false);
  }

}

export async function handleVideoQAFormSubmit(params, router, jobStageId, setBtnPopup, setOnLoadValues, from, jobData, setJobData, setDisabled, deleteQuestionList) {
  const videoQAModalService = new VideoQAModalService();
  params = setQuestionsValues(params);
  params.job_stage_id = params.id
  const result = await videoQAModalService.updateQuestions(params);

  if(result.request.status == 200)
  {
    setBtnPopup(false);
  }
  else
  {
    result.response.data.error;
  }
}

function setQuestionsValues(values, deleteQuestionList)
{
  values.questions_attributes = Object.assign( [], values.questions_attributes, deleteQuestionList)
  return values;
}


export async function getJobStageData(jobId, jobStageId, router)
{
  const result                =     await new Automation().jobStageData(jobId, jobStageId);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    return response;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    break;
  default: 
    handleOtherResponseCode(status_code, router);
  }
}

export async function getManualJobStageData(jobId, jobStageId, router)
{
  const result                =     await new Automation().manualJobStageData(jobId, jobStageId);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    return response;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    break;
  default:
    handleOtherResponseCode(status_code, router);
  }
}


export async function getTechTestData(value){
  const result                =     await new Automation().getTechTests(value);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();
  
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    return response.test_libraries;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    break;
  default: 
    handleOtherResponseCode(status_code);
  }
}

export async function getAssessmentTestData(value, isCustom){
  const result                =     await new Automation().getAssessmentTests(value);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();
  
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    let tests = response.test_libraries;
    if(!isCustom) tests.unshift({id: 'upload_new_test', name: 'Upload new test'})
    return tests;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    break;
  default: 
    handleOtherResponseCode(status_code);
  }
}

export async function getAutomationData(setApiError)
{
  // var job_id                  =   window.location.pathname.split('/').slice(-2)[0];
  var job_id                  =   new DataFromUrl().getJobId();
  const result                =   await new Automation().getJobStagesList(job_id);
  if(result.request.status == 200){
    let stages                  =   result.data.stages;
    let threshold               =   result.data.threshold;
    let step_name               =   result.data.step
    let status                  =   result.data.status
    let editable               =   result.data.editable
    let display_automation     =   result.data.display_automation
    let system_reference       =   result.data.system_reference
    let data                    =   {
                                      props: {
                                                status,
                                                step_name,
                                                stages,
                                                threshold,
                                                editable,
                                                display_automation,
                                                system_reference
                                              }
                                    }
    return data;
  }
  else{
    setApiError(result.request)
  }
}

export async function manageModals(setOldModal, setNewModal){
  await setOldModal(false)
  await setNewModal(true)
}

export function setTechTestFormData(params){
  let data = {
    job_stage: {
      automation: params.automation,
      job_test_detail_attributes: {
        id: params.job_test_detail_attributes.id,
        test_type: params.job_test_detail_attributes.test_type,
        test_id: params.job_test_detail_attributes.test_id,
        days_to_expire: params.job_test_detail_attributes.days_to_expire,
        member_emails: params.job_test_detail_attributes.member_emails
      }
    }
  }
  if(params.job_test_detail_attributes.test_id == 'upload_new_test'){
    let assessment = {
      name: params.job_test_detail_attributes.assessment.name,
      file_type: params.job_test_detail_attributes.assessment.file_type,
      link: params.job_test_detail_attributes.assessment.link
    }
    if(params.job_test_detail_attributes.assessment.id) assessment.id = params.job_test_detail_attributes.assessment.id
    if(params.job_test_detail_attributes.assessment.file) assessment.file = params.job_test_detail_attributes.assessment.file
    if(params.job_test_detail_attributes.assessment.filename) assessment.filename = params.job_test_detail_attributes.assessment.filename
    data.assessment = assessment
    data.save_and_continue = params.save_and_continue
  }
  return data;
}

export function interviewTypeHeader(intervieType){
  switch(intervieType){
    case INTERVIEW_TYPES.PHONE:
      return INTERVIEW_TYPE_HEADERS.PHONE
    case INTERVIEW_TYPES.VIDEO:
      return INTERVIEW_TYPE_HEADERS.VIDEO
    case INTERVIEW_TYPES.FACE2FACE:
      return INTERVIEW_TYPE_HEADERS.FACE2FACE
    case INTERVIEW_TYPES.TECHTEST:
      return INTERVIEW_TYPE_HEADERS.TECHTEST
    case INTERVIEW_TYPES.VIDEOQA:
      return INTERVIEW_TYPE_HEADERS.VIDEOQA
    default:
      return INTERVIEW_TYPE_HEADERS.DEFAULT
  }
}

export function defaultTestDetail(member_emails, member_initials){
  return {
    "test_id": '',
    "test_type": 'TestLibrary',
    "days_to_expire": '',
    "member_emails": member_emails || [],
    "member_initials": member_initials || [],
    "assessment": {
      name: '',
      file_type: 'link',
      link: '',
      file: '',
      filename: '',
      filesize: '',
    }
  } 
}

export function setUpTechTest(initialValues, techTestAction, currentStage) {
  if(initialValues.job_test_detail_attributes){
    initialValues.job_test_detail_attributes = techTestAction.setJobTestDetail(currentStage.job_test_detail_attributes)
  }
  else{
    initialValues.job_test_detail_attributes = defaultTestDetail([], [])
  }
  return initialValues
}

export function setUpVideoQAMember(initialValues, currentStage) {
  let videoqa = { member_emails: currentStage?.members?.map((x) => x.email ) || [],
                    member_initials: currentStage?.members?.map((x) => userHash(x) ) || []
                }
  initialValues.videoqa = videoqa
  return initialValues
}

export function isLocationDisabled(formik, current_index)
{
  let active_index = 0
  formik.values.job_meeting_details_attributes.map((item, index) => {
    if(index > current_index) {
      return
    }
    if(!item._destroy) active_index += 1
  })
  return active_index > 1
}


export async function setFormDirty(parentData, setParentData, index, is_dirty){
  let currentRecord = parentData[index]
  if(is_dirty && !currentRecord.is_dirty){
   currentRecord.is_dirty = true
  }
  else if(!is_dirty){
    currentRecord.is_dirty = false
  }
  parentData[index] = currentRecord
  await setParentData([...parentData])
}